'use client';

import * as React from 'react';
import { ThemeProvider as NextThemesProvider } from 'next-themes';
import type { ThemeProviderProps as NextThemesProviderProps } from 'next-themes';

// Define your component's props, extending or using NextThemesProviderProps as needed
interface ThemeProviderProps extends NextThemesProviderProps {
    children: React.ReactNode;
}

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
    // Remove SSR safety check for isMounted, as next-themes handles SSR.
    // const [isMounted, setIsMounted] = React.useState(false);

    // React.useEffect(() => {
    //     setIsMounted(true);
    // }, []);

    // if (!isMounted) {
    //     return <>{children}</>;
    // }

    return (
        <NextThemesProvider
            attribute="class"
            defaultTheme="system"
            enableSystem
            disableTransitionOnChange
            {...props}
        >
            {children}
        </NextThemesProvider>
    );
}
